import axios from "axios";
import TokenService from "./token.service";

// А-Ф: тревоги детектора «машина занята без программной команды» живут в
// central (там же, где очередь запуска). Токен кабинета кросс-валиден.
const centralApi = axios.create({
    baseURL:
        process.env.VUE_APP_ENV_CENTRAL_API_URL ||
        "https://api.antilaundry.ru/api",
    headers: {
        "Content-Type": "application/json",
    },
});

centralApi.interceptors.request.use((config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
        config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
});

class MachineAlertService {

    unacked() {
        return centralApi.get("machine-alert/unacked");
    }

    read(shopId?: number) {
        return centralApi.get("machine-alert/read", {
            params: shopId ? { shop_id: shopId } : {},
        });
    }

    // «Принято» — только owner/admin (бэкенд проверяет роль сам).
    ack(id: number) {
        return centralApi.post("machine-alert/ack", { id });
    }

    // А-Ф2: суточная сводка жёлтых сигналов активаций.
    summary() {
        return centralApi.get("machine-alert/summary");
    }

}

export default new MachineAlertService();
